import moment from "moment";

import { Day, DayArgs } from "./datePicker.type";
import { dayNames } from "./enums";

export const getNumberOfDays = (year: number, month: number) => {
  return 42 - new Date(year, month, 42).getDate();
};

export const getDayDetails = (args: DayArgs): Day => {
  const index = args.index - args.firstDay;
  const day = args.index % 7;
  let prevMonth = args.month - 1;
  let prevYear = args.year;
  if (prevMonth < 0) {
    prevMonth = 11;
    prevYear--;
  }

  const prevMonthNumberOfDays = getNumberOfDays(prevYear, prevMonth);
  const date =
    (index < 0 ? prevMonthNumberOfDays + index : index % args.numberOfDays) + 1;
  const month = index < 0 ? -1 : index >= args.numberOfDays ? 1 : 0;
  const timestamp = moment([args.year, args.month, date]).valueOf();

  return {
    date,
    day,
    month,
    timestamp,
    name: dayNames[day],
  };
};

export const getMonthDetails = (year: number, month: number) => {
  const firstDay = new Date(year, month).getDay() - 1;
  const numberOfDays = getNumberOfDays(year, month);

  const monthArray: Day[] = [];
  let currentDay: Day;

  let index = 0;
  const rows = 6;
  const cols = 7;

  for (let row = 0; row < rows; row++) {
    for (let col = 0; col < cols; col++) {
      currentDay = getDayDetails({
        index,
        numberOfDays,
        firstDay,
        year,
        month,
      });
      monthArray.push(currentDay);
      index++;
    }
  }
  return monthArray;
};

export const getYearsRange = (startYear: number, endYear: number) => {
  const years: number[] = [];
  for (let i = startYear; i <= endYear; i++) {
    years.push(i);
  }
  return years;
};
